import { ISelectItem } from '@lla-platform/core/core-ui'

export enum CallType {
  Unknown = 'Unknown',
  NewService = 'NewService',
  GeneralInquiry = 'GeneralInquiry',
  Voicemail = 'Voicemail',
  NotApplicable = 'NotApplicable'
}

export const CallTypeToLabel: Record<string, string> = {
  Unknown: 'Unknown',
  NewService: 'New service',
  GeneralInquiry: 'General inquiry',
  Voicemail: 'Voicemail',
  NotApplicable: 'N/A'
}

export const CallTypeItems: ISelectItem[] = Object.values(CallType).map((value) => ({
  label: CallTypeToLabel[value],
  value
}))
